<template>
  <div class="questionnaire-record-detail full-page">
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <div class="page-content">
        <DetailInfo
          :title="title"
          :description="description"
          :endTime="endTime"
        />
        <div class="check-box">
          <template v-if="options">
            <div
              class="question-item"
              v-for="(question, index) in options"
              :key="question.Id"
            >
              <div class="question-title">
                {{ index + 1 }}、{{ question.questionTitle
                }}<span class="optional">{{
                  question.questionType === 2 ? "（选填）" : ""
                }}</span>
              </div>

              <!-- 单选 -->
              <van-cell-group
                class="option-group"
                v-if="question.questionType === 0"
              >
                <van-cell
                  class="option-item"
                  v-for="option in question.options"
                  :key="option.optionId"
                  :title="option.option"
                >
                  <template #icon>
                    <img
                      class="img-check"
                      :src="
                        question.recordSlaveValue == option.optionId
                          ? radioActiveIcon
                          : radioInactiveIcon
                      "
                    />
                  </template>
                </van-cell>
              </van-cell-group>

              <!-- 多选 -->
              <van-cell-group
                class="option-group"
                v-if="question.questionType === 1"
              >
                <van-cell
                  v-for="option in question.options"
                  class="option-item"
                  :key="option.optionId"
                  :title="option.option"
                >
                  <template #icon>
                    <img
                      class="img-check"
                      :src="
                        question.recordSlaveValue
                          .split(',')
                          .map((item) => parseInt(item))
                          .includes(option.optionId)
                          ? checkboxActiveIcon
                          : checkboxInactiveIcon
                      "
                    />
                  </template>
                </van-cell>
              </van-cell-group>

              <!-- 填空 -->
              <van-cell-group
                class="option-group"
                v-if="question.questionType === 2"
              >
                <van-cell :title="question.recordSlaveValue" />
              </van-cell-group>
            </div>
          </template>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { questionnaireRecordDetailAPI } from "@/api/questionnaire";
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { checkResponse } from "@/assets/js/utils";
import DetailInfo from "@/components/DetailInfo";
export default {
  name: "QuestionnaireRecordDetail",
  components: { DetailInfo },
  data() {
    return {
      checkboxActiveIcon: require("@/assets/images/checkbox_active.png"),
      checkboxInactiveIcon: require("@/assets/images/checkbox_inactive.png"),
      radioActiveIcon: require("@/assets/images/radio_active.png"),
      radioInactiveIcon: require("@/assets/images/radio_inactive.png"),
      detailId: 0,
      isRefresh: false,
      title: "",
      description: "",
      endTime: undefined,
      options: null,
    };
  },
  mounted() {
    BridgeNativeMethods.setTitle("问卷调查");

    this.detailId = parseInt(this.$route.params.id);
    this.requestData();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      questionnaireRecordDetailAPI(this.detailId).then(
        (response) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
            let { title, describe, endTime, options } = response.data;
            this.title = title;
            this.description = describe;
            this.endTime = endTime;
            this.options = options;
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          if (this.isRefresh) this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log("activity detail err", err);
        }
      );
    },
    onRefresh() {
      this.isRefresh = true;
      this.requestData();
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  min-height: 100vh;
}

.check-box {
  overflow: hidden;
  margin-bottom: 16px;
}
.question-item {
  margin-top: 16px;
  background-color: #fff;
}
.question-title {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 48px;
  padding-left: 16px;

  &.van-hairline--bottom::after {
    left: -44%;
  }
}
.option-item::after {
  left: 62px;
}
.option-group.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  left: -44%;
}
.img-check {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
</style>